import { Filters } from '@components/utility/filters';
import { BulkActionOption, BulkActionsDropdown, Select } from '@components/utility/selects';
import { SelectChangeEvent } from '@mui/material';
import { renderCountryOption } from '@utils/common';

type MembersFiltersProps = {
    selectedCount: number;
    search: string;
    filters: Record<string, string[]>;
    roles: { label: string; value: string }[];
    salesManagers: { label: string; value: string | number }[];
    countries: { label: string; value: string }[];
    areRolesLoading: boolean;
    areSalesManagerLoading: boolean;
    areCountriesLoading: boolean;
    bulkOptions: BulkActionOption[];
    bulkActionsDisabled: boolean;
    bulkActionsTooltip: string;
    onSearchChange: (value: string) => void;
    onSearchClear: () => void;
    onFilterChange: (field: string, event: SelectChangeEvent<unknown>) => void;
    onFilterRemove: (field: string, value: string) => void;
    onClearFilters: () => void;
    getChipLabel: (filter: string, item: string) => string;
};

export const MembersFilters = ({
    selectedCount,
    search,
    filters,
    roles,
    salesManagers,
    countries,
    areRolesLoading,
    areSalesManagerLoading,
    areCountriesLoading,
    bulkOptions,
    bulkActionsDisabled,
    bulkActionsTooltip,
    onSearchChange,
    onSearchClear,
    onFilterChange,
    onFilterRemove,
    onClearFilters,
    getChipLabel,
}: MembersFiltersProps) => (
    <Filters
        searchInput={search}
        onSearchChange={(event) => onSearchChange(event.target.value)}
        onSearchClear={onSearchClear}
        searchPlaceholder="Search members by name, email or company"
        withFilterIcon={false}
        dividers={false}
        getChipLabel={getChipLabel}
        onChipClick={onFilterRemove}
        onClearFilterClick={onClearFilters}
        emblaCarouselOptions={{ dragFree: true }}
        searchSpan={3}
        activeFilters={filters}
        activeFiltersPlacement="bottom"
        right={
            <BulkActionsDropdown
                options={bulkOptions}
                disabled={bulkActionsDisabled}
                tooltip={bulkActionsTooltip}
                selectedCount={selectedCount}
            />
        }
    >
        <div className="grid grid-cols-3 gap-4">
            <Select
                fullWidth
                searchable
                multiple
                name="role"
                loading={areRolesLoading}
                size="small"
                label="Role"
                items={roles}
                fcSX={{ size: 'small' }}
                renderValue={(selected) => <div>{(selected as [])?.length} selected</div>}
                onChange={(event) => onFilterChange('role', event)}
                value={filters.role ?? []}
            />
            <Select
                fullWidth
                virtualize
                searchable
                multiple
                size="small"
                loading={areSalesManagerLoading}
                name="sales_manager"
                label="Sales Manager"
                items={salesManagers}
                value={filters.sales_manager ?? []}
                onChange={(event) => onFilterChange('sales_manager', event)}
            />
            <Select
                fullWidth
                searchable
                multiple
                name="country"
                size="small"
                label="Country"
                items={countries}
                loading={areCountriesLoading}
                renderValue={(selected) => <div>{(selected as [])?.length} selected</div>}
                value={filters.country ?? []}
                renderOption={renderCountryOption}
                onChange={(event) => onFilterChange('country', event)}
                virtualize
            />
        </div>
    </Filters>
);
